import { cn } from '@/lib/cn'

interface SpinnerProps {
  className?: string
  size?:      'sm' | 'md' | 'lg'
}

const SIZE_MAP = { sm: 'w-4 h-4', md: 'w-6 h-6', lg: 'w-8 h-8' }

export function Spinner({ className, size = 'md' }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn(
        'animate-spin rounded-full border-2 border-primary border-t-transparent',
        SIZE_MAP[size],
        className,
      )}
    />
  )
}
